import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          title: '首页',
          icon: 'dashboard',
          affix: true
        }
      }
    ]
  },
  {
    path: '/heatmap',
    component: () => import('@/views/manage/dsp/coordinate/heatmap'),
    hidden: true

  }
]

export const asyncRoutes = []

export const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})
